export const ODDS_TYPES = {
  american: 'american',
  decimal: 'decimal',
  fractional: 'fractional',
}

export const CALCULATOR_ODDS_FIELD = {
  american: 'american',
  decimal: 'decimal',
  fractional: 'fractional',
  impliedProbability: 'impliedProbability',
}

export const CALCULATOR_ODDS_DEFAULT_VALUE = {
  [ODDS_TYPES.american]: '100',
  [ODDS_TYPES.decimal]: '2.00',
  [ODDS_TYPES.fractional]: '1/1',
  stake: '100',
}

export const ODDS_TYPES_TERMS = {
  american: 'GC_ODDS_AMERICAN',
  decimal: 'GC_ODDS_DECIMAL',
  fractional: 'GC_ODDS_FRACTIONAL'
}

export const ARBITRAGE_CALCULATOR_BETS_QUANTITY = {
  two: '2 Bets',
  three: '3 Bets'
}

export const DEFAULT_ODDS_TYPE = ODDS_TYPES.decimal;

export const DUMMY_BOOKIE_ID = 16;
